import * as React from "react"
import {useAppSelector} from "../../redux/storeHooks";
import MemberFileCalendar from "./MemberFileCalendar";
import MemberFormInputs from "./MemberFormInputs";
import MemberFormFilesInput from "./MemberFormFilesInput";
import MemberContext from "./MemberContext";
import MemberFormSubmit from "./MemberFormSubmit";

const MemberForm = () => {

  const {editedFiles, processingFiles} = useAppSelector((store) => store.memberFilesState);

  return (
    <section className="section page--member">
      {editedFiles.length || processingFiles.length ? (
        <h2 className="h2 text-center black max-620 auto margin-b-30">
          Want to add new files? <span className="normal block">Let’s get started!</span>
        </h2>
      ) : null}
      <div className="container">
        <div className="flex flex--top flex--column-book">
          <div className="flex-item col col--big">
            <MemberContext.Consumer>
              {({uploadedFiles, setUploadedFiles}) => {
                return <MemberFormFilesInput uploadedFiles={uploadedFiles} setUploadedFiles={setUploadedFiles}/>
              }}
            </MemberContext.Consumer>
            <div className="member-item">
              <div className="flex flex--start member-item__title">
                <span className="member-item__icon member-item__icon--number">2</span>
                <span className="h4">Upon reaching out to a personal stories creator, you will receive a one-month content plan.</span>
              </div>
              <MemberFileCalendar/>
            </div>
          </div>
          <div className="flex-item col col--big">
            <div className="member-item">
              <div className="flex flex--start member-item__title">
                <span className="member-item__icon member-item__icon--number">3</span>
                <span className="h4">Submit the forms below.</span>
              </div>
              <MemberFormInputs/>
              <MemberContext.Consumer>
                {({uploadedFiles}) => {
                  return <MemberFormSubmit uploadedFiles={uploadedFiles}/>
                }}
              </MemberContext.Consumer>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default MemberForm
